import { Link } from 'react-router-dom'
import { calculateTopOfElement, memoChecker } from '../../../../utils/globals/components'
import { RouteChild, Routes } from '../../../CreateRoutering/types'
import TwinIcon, { TwinIconProp } from '../../../TwinIcon'
import { checkIfCurrentIcon } from '../IconMenuBar/functions'
import { CurrentPagePayload } from '../../../../utils/reducers/globals/currentPage'
import { AllReduxAppPayloads, GlobalContext } from '../../../../utils/reducers'
import { ConnectedProps, connect } from 'react-redux'
import { Fragment, memo, useCallback, useMemo, useRef, useState } from 'react'
import useOnClickOutside from '../../../../utils/hooks/useOnClickOut'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { faBookmark } from '@fortawesome/pro-light-svg-icons'
import { faBookmark as faBookmarkS } from '@fortawesome/pro-solid-svg-icons'
import { changeEmployeeParams } from '../../../../utils/reducers/reduxDispatch'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { BookMarkRoute, BookMarkRoutesParsedTy } from '../../../../app/erp/types'
import { ModalOpenedTy } from '../../../Modal/types'
import ModalPersonalizeBookmarks from './ModalPersonalizeBookmarks'

interface LeftMenuPrintItemsProps extends PrintMenuLogicProps {
}

const LeftMenuPrintItems: React.FC<LeftMenuPrintItemsProps> = (props) => {
    const { renderMenuItems, selectedIndex } = usePrintMenuLogic(props)
    return (
        <div className='flex mt-20 w-full'>
            {renderMenuItems.length > 0 && <MenuIconsColorBar selectedIndex={selectedIndex} />}
            <div className='menu_icon_wrapper grid gap-y-10'>
                {renderMenuItems}
            </div>
        </div>
    )
}
interface PrintMenuLogicProps extends ReduxLeftMenuConnector {
    routes: Routes
}

const usePrintMenuLogic = ({ routes, currentPage }: PrintMenuLogicProps) => {
    const renderMenuItems: JSX.Element[] = []
    let selectedIndex = 0
    for (const key in routes) {
        const route = routes[key]
        const isCurrentIconProps = checkIfCurrentIcon(currentPage?.routes[0] || '', route.link, key)
        selectedIndex = isCurrentIconProps.selectedIndex ?? selectedIndex
        if (route.icon) {
            renderMenuItems.push(<MenuIconItem text={route.text} key={key} link={route.link} icon={route.icon} {...isCurrentIconProps}></MenuIconItem>)
        } else if (isCurrentIconProps.selectedIndex){
            selectedIndex = -1
        }
    }
    return {
        renderMenuItems,
        selectedIndex
    }
}

interface MenuIconsColorBarProps {
    selectedIndex: number
    haveBookMarks?: boolean
}

const ICON_HEIGHT = 60
const GAP_BTW_ICONS = 10

const MenuIconsColorBar: React.FC<MenuIconsColorBarProps> = ({ selectedIndex, haveBookMarks }) => {
    const extraHeight = haveBookMarks ? 10 : 0
    return (
        <div className='h-full menu_icon_colorbar'>
            <div className='icon_colorbar_bar' style={{ opacity: selectedIndex === -1 ? 0 : 1, transition: selectedIndex === -1 ? 'none' : '0.3s', top: calculateTopOfElement(ICON_HEIGHT, GAP_BTW_ICONS, selectedIndex) + extraHeight }}></div>
        </div>
    )
}

interface MenuIconItemProps {
    icon: TwinIconProp
    link: string
    className?: string
    text: string
}

export const MenuIconItem: React.FC<MenuIconItemProps> = ({ link, icon, className, text }) => {
    return (
        <Link className={'flex items-center menu_icon_item flex-col text-white ' + (className || '')} to={link}>
            <TwinIcon icon={icon} size='2x' />
            <span className='regular9 menu_icon_new_text'>{text}</span>
        </Link>
    )
}

interface LeftMenuPrintItemsNew1Props extends PrintMenuLogicProps {}

const LeftMenuPrintItemsNew1: React.FC<LeftMenuPrintItemsNew1Props> = (props) => {
    const { renderMenuItems, selectedIndex } = usePrintMenuNew1Logic(props)
    return (
        <div className='flex mt-20 w-full'>
            {renderMenuItems.length > 0 && <MenuIconsColorBar selectedIndex={selectedIndex} haveBookMarks={props.bookMarkParsed?.length > 0} />}
            <div className='menu_icon_wrapper grid gap-y-10 relative text-white z-2'>
                {renderMenuItems}
            </div>
        </div>
    )
}
interface PrintMenuLogicProps extends ReduxLeftMenuConnector {
    routes: Routes
    bookMarkParsed: BookMarkRoute[]
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}

const usePrintMenuNew1Logic = ({ routes, currentPage, bookMarkParsed, bookMarkParsedDict }: PrintMenuLogicProps) => {
    const renderMenuItems: JSX.Element[] = []
    let selectedIndex = 0
    for (const key in routes) {
        const route = routes[key]
        const isCurrentIconProps = checkIfCurrentIcon(currentPage?.routes[0] || '', route.link, key)
        selectedIndex = isCurrentIconProps.selectedIndex ?? selectedIndex
        if (route.icon && route.childs) {
            renderMenuItems.push(<MenuIconItemNew1 key={key} icon={route.icon} route={route} {...isCurrentIconProps} currentPage={currentPage} isIconSelected={isCurrentIconProps.selectedIndex !== undefined} bookMarkParsedDict={bookMarkParsedDict} />)
            if(bookMarkParsed.length && parseInt(key) === 0){
                renderMenuItems.push(<div className='menu_new1_divider' key={'_divider'+key}></div>)
            }
        } else if (isCurrentIconProps.selectedIndex) {
            selectedIndex = -1
        }
    }
    return {
        renderMenuItems,
        selectedIndex
    }
}

interface MenuIconItemNew1Props {
    icon: TwinIconProp
    className?: string
    route: RouteChild
    currentPage: CurrentPagePayload
    isIconSelected: boolean
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}

const MenuIconItemNew1: React.FC<MenuIconItemNew1Props> = ({ icon, className, route, currentPage, isIconSelected, bookMarkParsedDict }) => {
    const { isOpened, setIsOpened, ref, myMemoHeight } = useMenuIconItemNew1()
    const currentPageSection = isIconSelected ? (currentPage?.routes[1] || '_BASE') : undefined
    const isBookmarkRoute = route?.link === '__bookmark'
    return (
        <div className={'flex flex-col items-center menu_icon_item cursor-pointer menu_icon_item_new1  z-2 ' + (className || '') + (isOpened ? ' parent_active' : '')} ref={ref} onClick={() => setIsOpened((old) => isBookmarkRoute ? true : !old)}>
            <TwinIcon icon={icon} size='2x' className={'text-white z-2 ' + (route.classNameIcon || '')} />
            <span className='regular9 menu_icon_new_text'>{route.text}</span>
            <div className={'menu_icon_item_new1_routes_container absolute z-1  ' + (isOpened ? 'active' : '')} style={{ top: myMemoHeight }}>
                <MenuIconItemNew1Menu route={route} onClickItem={(e) => { e.stopPropagation(); setIsOpened(false) }} currentPageSection={currentPageSection} currentPageChild={isIconSelected ? currentPage?.routes[2] : undefined} bookMarkParsedDict={bookMarkParsedDict} setIsOpened={setIsOpened} />
            </div>
        </div>
    )
}

const useMenuIconItemNew1 = () => {
    const ref = useRef<any>(null)
    const [isOpened, setIsOpened] = useState(false)

    const refCurrent= ref.current
    const myMemoHeight = useMemo(() => {
        if (refCurrent) {
            const parentOffsets = refCurrent.getBoundingClientRect()
            const topParentContainer = refCurrent.parentElement
            const topParentContainerOffsets = topParentContainer.getBoundingClientRect()
            const containerElement = refCurrent.querySelector('.menu_icon_item_new1_routes_container')
            const children = containerElement.querySelector('.menu_new1_routes_parent')
            const myScreenHeight = window.innerHeight

            if (children && containerElement) {
                containerElement.style.top = '-5000px'
                containerElement.style.display = 'initial'
                const childrenOffsets = children.getBoundingClientRect()
                const fullChildrenOffsetHeight = parentOffsets.top + childrenOffsets.height
                containerElement.removeAttribute('style')

                if (fullChildrenOffsetHeight > myScreenHeight) {
                    if (parentOffsets.top > childrenOffsets.height) {
                        return parentOffsets.height
                    }
                    return ''
                }
                return parentOffsets.top - topParentContainerOffsets.top - 20
            }
        }

        return ''
    }, [refCurrent])

    useOnClickOutside(ref, () => setIsOpened(false))

    return { isOpened, setIsOpened, ref, myMemoHeight }
}

interface MenuIconItemNew1MenuProps {
    route: RouteChild
    onClickItem: React.MouseEventHandler
    currentPageSection?: string
    currentPageChild?: string
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
    setIsOpened: React.Dispatch<React.SetStateAction<boolean>>
}

const MenuIconItemNew1Menu: React.FC<MenuIconItemNew1MenuProps> = memo(({route, currentPageSection, setIsOpened, ...rest}) => {
    const {t} = useTwinTranslation()
    const renderThis: JSX.Element[] = []
    const isBookMark = route.link === '__bookmark'
    if(route.component && route.component?.name && route.component.name !== 'NullComponent'){
        const dashboardText = t('dashboard', 'Dashboard')
        const parentActive = currentPageSection && currentPageSection === "_BASE" ? true : false
        renderThis.push(<MenuIconNew1Section text={dashboardText} routes={[{ link: '/', text: dashboardText + ' ' + route.text, parsedLink: route.link }]} key='dashboard' {...rest} parentActive={parentActive} currentPageChild={'/'} />)
    }
    if(route.childs){
        for (const key in route.childs) {
            const element = route.childs[key]
            const parentActive = currentPageSection && currentPageSection === element.link ? true : false
            if (element?.childs?.length) {
                renderThis.push(<MenuIconNew1Section text={element.text} routes={element.childs || []} key={(element.parsedLink || element.link)+key} {...rest} parentActive={parentActive} />)
            }
        }
    }
    return (
        <div className='menu_new1_routes_parent flex flex-col flex-auto bg-gray-3E'>
            <div className='new1_route_title medium16 bg-gray-33 w-full px-16 py-10'>{route.text}</div>
            <div className='p-10 routes_sections flex flex-col gap-y-10'>
                {renderThis}
                {isBookMark ? <ButtonPersonalizeBookmarks bookMarkParsedDict={rest.bookMarkParsedDict || {}} setIsOpened={setIsOpened}/> : null}
            </div>
        </div>
    )
}, (oldProps, nextProps) => memoChecker(oldProps, nextProps, ['route', 'currentPageChild', 'currentPageSection', 'bookMarkParsedDict']))

interface MenuIconNew1SectionProps extends MenuIconNew1SectionLogicProps {
    text: string
    routes: RouteChild[]
    onClickItem: React.MouseEventHandler
    parentActive: boolean
    currentPageChild?: string
}

const MenuIconNew1Section: React.FC<MenuIconNew1SectionProps> = ({ text, routes, onClickItem, parentActive, currentPageChild, bookMarkParsedDict }) => {
    const { onAddBookmark, onRemoveBookmark } = useMenuIconNew1SectionLogic({ bookMarkParsedDict })
    const renderThis: JSX.Element[] = []
    for (const key in routes) {
        const element = routes[key]
        let extraClassName = ''
        let myIcon: JSX.Element | null = null
        if (bookMarkParsedDict?.[element.parsedLink || element.link]){
            myIcon = <TwinIcon className='ml-auto bookmark_icon hidden mr-5' icon={faBookmarkS} onClick={(e) => onRemoveBookmark(e, element)} />
            extraClassName += ' active_bookmark'
        }else{
            myIcon = <TwinIcon className='ml-auto bookmark_icon hidden mr-5' icon={faBookmark} onClick={(e) => onAddBookmark(e, element)} />
        }
        const childActive = parentActive && currentPageChild === element.link
        renderThis.push(
            <Link to={element.parsedLink || element.link} className={(childActive ? 'medium14 active' : 'light14') + ' item_new1_menu flex items-center' + extraClassName} onClick={onClickItem} key={'sectionLink' + (element.parsedLink || element.link) + key}>
                {element.text}
                {myIcon}
            </Link>
        )
    }
    return (
        <Fragment>
            <div className='menu_new1_section flex flex-col gap-y-2'>
                <span className='medium16 px-5'>{text}</span>
                <div className='flex flex-col gap-y-2 relative'>
                    {renderThis}
                </div>
            </div>
            <div className='menu_new1_divider mx-5' key={text + 'div'}></div>
        </Fragment>
    )
}

interface MenuIconNew1SectionLogicProps {
    bookMarkParsedDict: BookMarkRoutesParsedTy | undefined 
}

const useMenuIconNew1SectionLogic = ({ bookMarkParsedDict }: MenuIconNew1SectionLogicProps) => {
    const onAddBookmark = useCallback(async (e: any, element: RouteChild) => {
        let bookMarkRoutes = []
        for (const key in bookMarkParsedDict) {
            const element = bookMarkParsedDict[key]
            bookMarkRoutes.push(element)
        }
        bookMarkRoutes = bookMarkRoutes.sort((a, b) => a.key - b.key)
        e.stopPropagation()
        e.preventDefault()
        const preparedToAdd = {
            link: element.parsedLink || element.link,
            text: element.text,
            key: bookMarkRoutes.length
        }
        if(!bookMarkParsedDict?.[element.parsedLink || element.link]){
            bookMarkRoutes.push(preparedToAdd)
        }
        const myValuesStr = JSON.stringify(bookMarkRoutes)
        await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'bookMarkRoutes', value: myValuesStr })
        changeEmployeeParams({ 'bookMarkRoutes': myValuesStr })
    }, [bookMarkParsedDict])

    const onRemoveBookmark = useCallback(async (e: any, element: RouteChild) => {
        let bookMarkRoutes = []
        delete bookMarkParsedDict?.[element.parsedLink || element.link]
        for (const key in bookMarkParsedDict) {
            const element = bookMarkParsedDict[key]
            bookMarkRoutes.push(element)
        }
        bookMarkRoutes = bookMarkRoutes.sort((a, b) => a.key - b.key)
        e.stopPropagation()
        e.preventDefault()
        const myValuesStr = JSON.stringify(bookMarkRoutes)
        await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'bookMarkRoutes', value: myValuesStr })
        changeEmployeeParams({ 'bookMarkRoutes': myValuesStr })
    }, [bookMarkParsedDict])

    return { onAddBookmark, onRemoveBookmark }
}

interface ButtonPersonalizeBookmarksProps {
    bookMarkParsedDict: BookMarkRoutesParsedTy
    setIsOpened: React.Dispatch<React.SetStateAction<boolean>>
 }

const ButtonPersonalizeBookmarks: React.FC<ButtonPersonalizeBookmarksProps> = ({ bookMarkParsedDict, setIsOpened }) => {
    const { t } = useTwinTranslation()
    const { opened, setOpened } = useButtonPersonalizeBookmarksLogic()
    return (
        <Fragment>
            <div className='menu_new1_section '>
                <div className='light14 item_new1_menu flex items-center cursor-pointer' onClick={() => { setOpened(true);  setIsOpened(true)}}>{t('personalize', 'Personalizar')}</div>
                {opened ? <ModalPersonalizeBookmarks bookMarkParsedDict={bookMarkParsedDict} setOpened={setOpened} /> : null }
            </div>
        </Fragment>
    )
}

const useButtonPersonalizeBookmarksLogic = () => {
    const [opened, setOpened] = useState<ModalOpenedTy>(null)
    return { opened, setOpened }
}

const leftMenuDispatch = {
    setChangePage: (payload: CurrentPagePayload) => ({ type: 'CHANGE_CURRENTPAGE', payload }),
}
const mapLeftMenuConnector = (state: AllReduxAppPayloads) => ({ currentPage: state.currentPage })
export const leftMenuConnector = connect(mapLeftMenuConnector, leftMenuDispatch, null, { context: GlobalContext })
export type ReduxLeftMenuConnector = ConnectedProps<typeof leftMenuConnector>

export const LeftMenuPrintItemsConnect = leftMenuConnector(LeftMenuPrintItems)
export const LeftMenuPrintItemsNew1Connect = leftMenuConnector(LeftMenuPrintItemsNew1)
